import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App.tsx";
import { AuthProvider } from "hooks/useAuth";
import { AutoLogoutProvider } from "contexts/AutoLogoutContext";

ReactDOM.render(
  <AuthProvider>
    <AutoLogoutProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AutoLogoutProvider>
  </AuthProvider>,
  document.getElementById("root")
);
